import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";
import SessionController from "../../shared/session";
import {loadCategories, getCategoryLabel} from "./category_helper";

import {
    getBackgroundClass,
    getCourseLabelResult,
    getLabelMyClass,
    getLabelResult
} from "../../shared/utilities/status_utilities";
import {isCourseExpired} from "../../shared/utilities/courseEnrolmentStatus_utilities";
import iconGridSolid from "../../shared/img/icon-grid-solid.svg";
import Loading from "../../shared/loading";
import RouterService from "../../shared/services/router.service";
import MultiSelectDropdown from "../../shared/components/Component_MultiSelectDropdown";

let loading,
    filter,
    orderBy,
    search,
    myCourses;


let state = {
    categoryFilter: [],
    categories: []
};

function loadCourses() {
    loading = true;
    let params = [];
    if (filter) {
        params.push('filter=' + filter);
    }
    if (state.categoryFilter && state.categoryFilter.length > 0) {
        state.categoryFilter.forEach(cat => {
            params.push(`categories=${encodeURIComponent(cat)}`);
        });
    }
    if (search) {
        params.push('search=' + search);
    }
    if (orderBy) {
        params.push('orderBy=' + orderBy);
    }

    Requester.get(Gateway.public + 'courses/my-courses' + (params.length > 0 ? '?' + params.join('&') : ''))
        .then(function (result) {
            myCourses = result.courses;
        })
        .catch(function (error) {
            console.log('error', error);
            Toasts.add('error', i18n.t('error'), i18n.t(error.response?.properties.errorCode));
            myCourses = [];
        })
        .finally(function () {
            loading = false;
        });
}

const PublicComponent_My_Courses = {
    oninit: function () {
        loadCourses();
        loadCategories(state);
    },
    view: function () {
        return [
            m('.centered-layout center-this', [
                !loading ? [
                    m('.toolbar courses-toolbar', {class: loading ? 'disable-buttons' : ''}, [
                        m('.has-icon-right search-courses', [
                            m('input[type=search].SecondaryTheme', {
                                oninput: function () {
                                    search = this.value;
                                }, onkeyup: function (e) {
                                    if (e.keyCode === 13) {
                                        loadCourses();
                                    }
                                }, value: search, placeholder: i18n.t('search')
                            }),
                            m('i.icon-x c-hand', {
                                onclick: function () {
                                    search = null;
                                    loadCourses();
                                },
                            }),
                            m('i.icon-search c-hand', {
                                onclick: function () {
                                    loadCourses();
                                }
                            })
                        ]),
                        m('.toolbar-section courses-toolbar-item', [
                            m(MultiSelectDropdown, {
                                label: () => getCategoryLabel(state),
                                options: state.categories,
                                selected: state.categoryFilter,
                                allLabel: i18n.t("all_types"),

                                getLabel: (item) => item.isEditable
                                    ? item.name
                                    : i18n.t("category_" + item.name.toLowerCase().replace(/\s+/g, "_")),

                                getValue: (item) => item.name.toLowerCase(),

                                searchable: true,

                                optionGroups: (function () {
                                    const standard = (state.categories || []).filter(c => !c.isEditable);
                                    const custom = (state.categories || []).filter(c => c.isEditable).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
                                    const groups = [{ label: null, items: standard }];
                                    if (custom.length > 0) groups.push({ label: i18n.t("custom_course_categories"), items: custom });
                                    return groups;
                                })(),

                                onChange: (newValue) => {
                                    state.categoryFilter = newValue;
                                    loadCourses();
                                }
                            })
                        ]),
                        m('.toolbar-section courses-toolbar-item', [
                            m('.dropdown', {class: SessionController.session && SessionController.session.identity ? '' : 'disabled'},
                                m('button.btn.btn-secondary pl-2 pr-1 ml-2', [
                                    filter ? i18n.t(filter) : [m('i.icon-filter'), i18n.t('all_my_courses')],
                                    m('i.icon-back rotate-270 ml-2')
                                ]),
                                m('.dropdown-list mb-0 pb-0', [
                                    m('div', {
                                        class: !filter ? 'active' : '', onclick: function () {
                                            filter = null;
                                            loadCourses();
                                        }
                                    }, i18n.t('all_my_courses')),
                                    m('div', {
                                        class: filter === 'passed' ? 'active' : '', onclick: function () {
                                            filter = 'passed';
                                            loadCourses();
                                        }
                                    }, i18n.t('passed')),
                                    m('div', {
                                        class: filter === 'in_progress' ? 'active' : '',
                                        onclick: function () {
                                            filter = 'in_progress';
                                            loadCourses();
                                        }
                                    }, i18n.t('in_progress')),
                                    m('div', {
                                        class: filter === 'not_started' ? 'active' : '',
                                        onclick: function () {
                                            filter = 'not_started';
                                            loadCourses();
                                        }
                                    }, i18n.t('not_started')),
                                    m('div', {
                                        class: filter === 'failed' ? 'active' : '', onclick: function () {
                                            filter = 'failed';
                                            loadCourses();
                                        }
                                    }, i18n.t('failed')),
                                ])
                            ),

                        ]),
                        m('.toolbar-section courses-toolbar-item', [
                            m('.dropdown', {class: SessionController.session && SessionController.session.identity ? '' : 'disabled'},
                                m('button.btn.btn-secondary pl-2 pr-1 ml-2', [
                                    orderBy ? i18n.t(orderBy) : i18n.t('courseName'),
                                    m('i.icon-back rotate-270 ml-2')
                                ]),
                                m('.dropdown-list mb-0 pb-0', [
                                    m('div', {
                                        class: !orderBy ? 'active' : '', onclick: function () {
                                            orderBy = null;
                                            loadCourses();
                                        }
                                    }, i18n.t('courseName')),
                                    m('div', {
                                        class: orderBy === 'failed' ? 'active' : '', onclick: function () {
                                            orderBy = 'courseNameDesc';
                                            loadCourses();
                                        }
                                    }, i18n.t('courseNameDesc')),
                                    m('div', {
                                        class: orderBy === 'creationDate' ? 'active' : '',
                                        onclick: function () {
                                            orderBy = 'creationDate';
                                            loadCourses();
                                        }
                                    }, i18n.t('creationDate')),
                                    m('div', {
                                        class: orderBy === 'creationDateDesc' ? 'active' : '',
                                        onclick: function () {
                                            orderBy = 'creationDateDesc';
                                            loadCourses();
                                        }
                                    }, i18n.t('creationDateDesc')),
                                    m('div', {
                                        class: orderBy === 'lastModifiedDate' ? 'active' : '', onclick: function () {
                                            orderBy = 'lastModifiedDate';
                                            loadCourses();
                                        }
                                    }, i18n.t('lastModifiedDate')),
                                    m('div', {
                                        class: orderBy === 'lastModifiedDateDesc' ? 'active' : '',
                                        onclick: function () {
                                            orderBy = 'lastModifiedDateDesc';
                                            loadCourses();
                                        }
                                    }, i18n.t('lastModifiedDateDesc'))
                                ])
                            ),

                        ]),
                        m('button.btn.btn-secondary searchButton ml-2 courses-toolbar-item', {
                            onclick: function () {
                                loadCourses();
                            },
                        }, i18n.t('search')),
                    ]),
                    !myCourses || myCourses.length == 0 ? [m('.text-center mt-5', !search && !filter ? [i18n.t('no_my_courses') + ' ', m('strong', i18n.t('select_all_course_tab_name'))] : i18n.t('no_courses_filter'))] :
                        [
                            m('.mt-1', [
                                m('.course-box-list', myCourses.map(function (course, index) {
                                    return [
                                        m(m.route.Link, {href: RouterService.getPublicCourseUrl(course.id)},
                                            m('.flex-column', [
                                                course.imagePath && m('.img relative', {style: !!course.imagePath ? 'background-image: url(\'' + course.imagePath + '\')' : ''}),
                                                !course.imagePath && m('.defaultCourseImage', [m.trust(iconGridSolid)]),
                                                m('.padding flex-column flex-auto full-height pb-0', [
                                                    m('.flex-auto full-height', [
                                                        m('.text-bold', course.name),
                                                    ]),
                                                    (function () {
                                                        const stdCats = (course.categories || [])
                                                            .filter(function (c) { return !c.isEditable; })
                                                            .sort(function (a, b) { return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase()); });
                                                        if (!stdCats.length) return null;
                                                        return m('div', stdCats.map(function (cat) {
                                                            return m('span.category-tag', {
                                                                class: cat.name ? cat.name.replace(/\s+/g, '-').toLowerCase() : '',
                                                                key: cat.name
                                                            }, i18n.t('category_' + (cat.name || 'unassigned').replace(/\s+/g, '_').toLowerCase()));
                                                        }));
                                                    })(),
                                                    m('.form-buttons justify-between', [
                                                        m('div', [
                                                            course?.selfEnrolmentExpires && isCourseExpired(course) ? m('.flex-row align-center', [m('.boxed-pill bg-error', i18n.t("expired"))]) : '',
                                                            course.enrolment ? m('.label-circle', {class: getLabelMyClass(course.enrolment)}, getCourseLabelResult(course.enrolment)) : m('div')
                                                        ]),

                                                        m('button.btn.btn-primary', [
                                                            course.enrolment ? i18n.t('openCourse') : i18n.t('courseDetails')
                                                        ]),
                                                    ]),
                                                ]),
                                                course.enrolment ? [
                                                    m('.course-progress-bar', m('div', {
                                                        style: 'width: ' + course.enrolment.percentageComplete + '%',
                                                        class: course.enrolment.isCompleted ? (course.enrolment.isPassed ? 'bg-success' : 'bg-error') : course.enrolment.isStarted ? 'bg-warning' : ''
                                                    }))
                                                ] : m('div', {style: 'height: 5px;'})
                                            ])
                                        )
                                    ];
                                }))
                            ])
                        ]

                ] : m(Loading)
            ])
        ];
    }
};
export default PublicComponent_My_Courses;
